import { EnemyType } from './types';

export interface SpawnGroup {
  enemyType: EnemyType;
  count: number;
  interval: number;
  startDelay: number;
}
/**
 * A wave's ability toggles — the test arenas' five, carried by a wave itself
 * (the Level Creator's waves, spec 2026-11-01). Absent = everything live.
 */
export interface WaveMods {
  disableStun?: boolean;
  disableFireSlow?: boolean;
  disableControl?: boolean;
  disableTowerFire?: boolean;
  disableBossAbility?: boolean;
}
export interface WaveDef {
  groups: SpawnGroup[];
  mods?: WaveMods;
}
export interface Spawn {
  enemyType: EnemyType;
}

export class WaveRunner {
  private t = 0;
  private emitted: number[];
  constructor(private readonly wave: WaveDef) {
    this.emitted = wave.groups.map(() => 0);
  }
  update(dt: number): Spawn[] {
    this.t += dt;
    const out: Spawn[] = [];
    // emit at the current time after advancing, so t=0 yields the first spawn
    this.wave.groups.forEach((g, i) => {
      while (this.emitted[i] < g.count && this.t >= g.startDelay + this.emitted[i] * g.interval) {
        out.push({ enemyType: g.enemyType });
        this.emitted[i]++;
      }
    });
    return out;
  }
  /**
   * Cancel everything still to spawn: the runner reports `finished` at once
   * and emits nothing more, but it stays in the sim's `runners` list.
   *
   * That distinction matters. GameSim's wave branch is gated on
   * `runners.length > 0`, so DROPPING the runners would stop the whole
   * simulation — no abilities, no win check, the board frozen. Prince Nacho's
   * second form uses this to cancel his honour guard ("when he spawns no
   * enemys spawn on the track") while the fight carries on around him.
   */
  cancelRemaining(): void {
    this.emitted = this.wave.groups.map((g) => g.count);
  }

  get finished(): boolean {
    return this.wave.groups.every((g, i) => this.emitted[i] >= g.count);
  }
}
